import { motion } from "framer-motion";
import styled, { css } from "styled-components";
import { IInputProps } from "components/input/i-input";

export const CustomInputWrapper = styled.div`
   position: relative;
   display: inline-block;
   width: 100%;
   margin-bottom: 2em;
`;

export const Badge = styled.span`
   color: ${({ theme }) => theme.colors?.white};
   background: ${({ theme }) => theme.colors?.primary};
   font-weight: 500;
   padding: 0 10px;
   font-size: 14px;
   display: flex;
   align-items: center;
   border-radius: 5px;
`;

export const Label = styled.label`
   pointer-events: none;
   white-space: nowrap;
   margin-bottom: 0.3rem;
   font-size: 16px;
   display: block;
   font-weight: 400;
   color: ${({ theme }) => theme.colors?.black};
   transition: font-weight ease-in-out 0.2s;

   ${CustomInputWrapper}:focus-within & {
      color: ${({ theme }) => theme.colors?.black};
      font-weight: 600;
   }
`;

export const InputDivWrapper = styled.div`
   display: flex;
   justify-content: center;
   flex-direction: column;
   border: solid 1px ${({ theme }) => theme.colors?.black};
   height: 65px;
   padding: 5px 10px;
   border-radius: 5px;
`;

export const InputWrapper = styled.div`
   display: flex;
   height: 45px;
   justify-content: space-between;

   input {
      height: 40px;
      border: none;
   }
`;

export const ErrorP = styled(motion.p)<{ easyFlow?: boolean }>`
   margin: 0.1rem 0 0 0;
   color: ${({ theme }) => theme.colors?.error};
   font-size: 14px;
   letter-spacing: -0.01rem;
   font-weight: 400;

   ${({ easyFlow }) =>
      easyFlow &&
      css`
         margin: 0;
         position: absolute;
         left: 65px;
         bottom: -21px;
         font-size: 11.5px;
      `}
`;

export const InputField = styled.input<IInputProps>`
   width: 100%;
   border: none;
   outline: none;
   font-size: 16px;
   appearance: none;
   border-radius: 0;
   padding: 0 ${({ startAdornment }) => (startAdornment ? "3.8rem" : "1rem")};
   box-sizing: border-box;
   border-radius: 0px;
   border: 1px solid ${({ theme }) => theme.colors?.black};
   background-color: transparent;
   height: 50px;

   &:focus {
      border-left: 1px solid grey;
   }
`;

export const TagText = styled.small`
   color: ${({ theme }) => theme.colors?.black};
   font-style: italic;
   max-width: 500px;
`;
